<template>
  <div>
    <v-dialog v-model="show" :max-width="640" flat elevation="0" persistent>
      <v-card color="greyColorLigthTwo" class="rounded-lg py-0 px-0">
        <v-card-title v-if="joinStatus" class="px-0 py-0">
          <v-layout justify-center align-center>
            <session-component
              :sessionId="sessionId"
              :apiKey="apiKey"
              :token="token"
              :publisher="true"
              @streamDestroyed="streamDestroyed"
              @streamCreated="(n) => streamCreated(n)"
            />
          </v-layout>
          <v-layout v-if="showEnd" justify-center align-center class="my-10">
            <v-btn
              color="defaultColor"
              class="white--text text-capitalize rounded-pill px-15"
              height="67"
              elevation="0"
              rounded
              large
              :loading="showEndButtonLoading"
              @click="endLiveStream()"
            >
              {{ $t("buttons.endStream") }}
            </v-btn>
          </v-layout>
          <v-layout v-if="!showEnd" justify-center align-center class="my-10">
            <div
              class="defaultColor--text font-weight-regular text-center px-12"
              style="font-size: 15px; line-height: 25px"
            >
              {{ $t("description.streamStarting") }}
            </div>
          </v-layout>
        </v-card-title>

        <v-card-title
          v-else-if="loading && !streamDestroyedStatus"
          class="pb-7"
        >
          <loading-progress :status="loading" />
        </v-card-title>

        <v-card-title v-else-if="!loading && streamDestroyedStatus">
          <div
            class="defaultColor--text font-weight-regular text-center px-12"
            style="font-size: 15px; line-height: 25px; width: 100%"
          >
            {{ $t("description.endLiveStream") }}
          </div>
        </v-card-title>
      </v-card>

      <!-- <dialog-close-button @clickButton="closeModal" /> -->
    </v-dialog>
  </div>
</template>

<script>
import DialogCloseButton from "../General/DialogCloseButton.vue";
import BroadcastService from "../../services/BroadcastService";
import SessionComponent from "./Session.vue";
import LoadingProgress from "../General/LoadingProgress.vue";
import UserListItem from "../Users/UserListItem.vue";

export default {
  data() {
    return {
      sessionId: null,
      apiKey: null,
      token: null,
      streamDestroyedStatus: false,
      loading: true,
      showEnd: false,
      showEndButtonLoading: false,
    };
  },
  props: {
    visible: Boolean,
  },
  mounted() {},
  components: {
    DialogCloseButton,
    SessionComponent,
    LoadingProgress,
    UserListItem,
  },
  methods: {
    startLiveStream() {
      this.loading = true;
      BroadcastService.getCredentials()
        .then((res) => {
          this.apiKey = res.data.ApiKey.toString();
          this.sessionId = res.data.SessionId;
          this.token = res.data.Token;
          this.loading = false;
          this.startBroadcast();
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {});
    },

    startBroadcast() {
      setTimeout(() => {
        BroadcastService.startBroadcast()
          .then((res) => {
            this.showInfo(
              this.$t("description.streamStarted"),
              "standart",
              "success"
            );
            this.showEnd = true;
          })
          .catch((err) => {
            this.showInfo(
              this.$t("description.streamNotStart"),
              "standart",
              "error"
            );
            this.closeModal();
          })
          .then(() => {});
      }, 2000);
    },

    streamDestroyed() {
      console.log("streamDestroyeddd");
      this.apiKey = null;
      this.sessionId = null;
      this.token = null;
      this.loading = false;
      this.streamDestroyedStatus = true;
    },

    endLiveStream() {
      this.loading = true;
      this.showEndButtonLoading = true;
      BroadcastService.stopBroadcast()
        .then((res) => {
          console.log("Stream is ended", res.data);
        })
        .catch(async (err) => {
          showError(err);
          this.closeModal();
        })
        .then(() => {
          this.loading = false;
          this.showEndButtonLoading = false;
          this.closeModal();
        });
    },

    streamCreated(n) {
      console.log("streamcreateed : ", n);
      //this.width = n.videoDimensions.width;
    },

    closeModal() {
      this.sessionId = null;
      this.apiKey = null;
      this.token = null;
      this.streamDestroyedStatus = false;
      this.loading = false;
      this.show = false;
      this.showEnd = false;
      this.showEndButtonLoading = false;
      this.$store.state.liveStreamDialogStatus = false;
      this.$router.go();
    },
  },
  computed: {
    show: {
      get() {
        if (this.visible) {
          this.startLiveStream();
        }
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
    joinStatus() {
      if (this.apiKey && this.sessionId && this.token) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {},
};
</script>
